import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import {
  AppService,
  CartService,
  I18nService,
  ITrack,
  LgType,
  PlayerListenerComponentDirective,
  PlayerLogic,
  SetColorsService
} from 'core'

@Component({
  selector: 'bmprod-footer',
  templateUrl: './bmprod-footer.component.html',
  styleUrls: ['./bmprod-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodFooterComponent extends PlayerListenerComponentDirective<ITrack> implements OnInit {
  lg: LgType
  colorSettingsMode = false

  footerLogoUrl: string
  beatmakerName: string
  currentYear: number

  routes: Array<string> = ['home', 'catalog', 'user-agreement', 'cookie-policy']

  constructor(
    public player: PlayerLogic,
    protected cartService: CartService,
    private setColorsService: SetColorsService,
    private i18nService: I18nService,
    private appService: AppService
  ) {
    super(player, cartService)
  }

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.getBeatmakerData()
    this.getCurrentYear()
    this.getColorSettingsMode()
  }

  getBeatmakerData() {
    this.appService.beatMakerDataSubject.subscribe(res => {
      if (res) {
        this.footerLogoUrl = res.footerLogoUrl
        this.beatmakerName = res.beatmakerName
      }
    })
  }

  getCurrentYear() {
    this.currentYear = new Date().getFullYear()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
